import Vue from 'vue'

const Functions = {
    formatDateFirebase(seconds){
        return new Date(seconds * 1000).toLocaleDateString()
    },

    formatDateString(stringDate)
    {
      let formatedDate = ''

      if(stringDate)
      {
        let dt = new Date(stringDate)
        let day = dt.getDate().toString()
        let dayF = (day.length == 1) ? `0${day}` : day
        let month = (dt.getMonth()+1).toString()
        let monthF = (month.length == 1) ? `0${month}` : month
        let yearF = dt.getFullYear()
        formatedDate = `${dayF}/${monthF}/${yearF}`
      }

      return formatedDate
    },

    dateStringMonth(stringDate, moreMonth = 1)
    {
      let formatedDate = ''

      if(stringDate)
      {
        let dt = new Date(stringDate)
        let day = dt.getDate().toString()
        let dayF = (day.length == 1) ? `0${day}` : day
        let month = (dt.getMonth()+moreMonth).toString()
        let monthF = (month.length == 1) ? `0${month}` : month
        let yearF = dt.getFullYear()
        formatedDate = `${yearF}-${monthF}-${dayF}`
      }

      return formatedDate
    },

    formatCpf(valor) {
      return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
    },

    formatTelefone(item) {
      return item.replace(/(\d{2})(\d{5})(\d{4})/g, "($1) $2-$3");
    },

    removeFormatTelefone(value) {
      return value.replace(/[()-\s]/g, '')
    },

    removeFormatCpf(value) {
      return value.replace(/[^0-9]/g, '')
    },

    dividirArray(arrOriginal, length) {
      let newArr = [[]]
      let groupIndex = 0

      for(let i = 0; i < arrOriginal.length; i++) {
        if(newArr[groupIndex] === undefined)
          newArr[groupIndex] = []

        newArr[groupIndex].push(arrOriginal[i])

        if((i + 1) % length === 0)
          groupIndex += 1
      }

      return newArr
    },

    convertUintArrayToUrl(uintArray) {
      let blob = new Blob([uintArray], { 'type': 'application/pdf' })
      let url = URL.createObjectURL(blob)
      return url
    },

    convertHexToRgb(hex) {
      let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
      if(result) {
        let color = {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        }

        color.r = ((color.r * 100) / 255) * 0.01
        color.g = ((color.g * 100) / 255) * 0.01
        color.b = ((color.b * 100) / 255) * 0.01

        return color
      }

      return null
    },

}

export default Functions
Vue.prototype.$functions = Functions
